/**
 * Well-known system user ids (mirror of backend/src/constants/system-users.ts).
 * The DELETED_USER sentinel owns content previously authored by permanently
 * deleted users; the UI renders it greyed-out (audit #7).
 */
export const DELETED_USER_ID = '00000000-0000-0000-0000-000000000000';
